// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__BlockMenu__root","visible":"cms__BlockMenu__visible","button":"cms__BlockMenu__button","expanded":"cms__BlockMenu__expanded","collapsed":"cms__BlockMenu__collapsed","pluginForm":"cms__BlockMenu__pluginForm","menu":"cms__BlockMenu__menu","control":"cms__BlockMenu__control","label":"cms__BlockMenu__label","widget":"cms__BlockMenu__widget","footer":"cms__BlockMenu__footer"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/BlockMenu.css
// module id = 557
// module chunks = 0